import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

export const AnalogTimePicker = ({
    value,
    onChange,
    label,
    disabled = false,
    fullWidth = false,
    size = 'medium',
    slotProps = {},
}) => (
    <TimePicker
        label={label}
        disabled={disabled}
        value={value}
        onChange={onChange}
        format="HH:mm"
        ampm={false}
        ampmInClock={false}
        views={['hours', 'minutes']}
        viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
        }}
        slotProps={{
            ...slotProps,
            textField: {
                fullWidth,
                size,
                ...slotProps.textField,
            },
        }}
    />
);
